import {React, useContext} from 'react'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurPartnersSection from './OurPartnersSection'
import ThanksLettersSection from './ThanksLettersSection'
import FeedbackSection from './FeedbackSection'
import bg_img_4 from './static/img/bg-img4.jpg'
import ygtyyarnama_img from "./static/img/ygtyyarnama.jpg"
import RoutesContext from '../contexts/RoutesContext'

function AboutCompanyPage(props) {
    let routes_context = useContext(RoutesContext)
  return (
   
    <main onLoad={routes_context.floating_section_loaded}>
        <BreadcrumbsSection routes={routes_context.routes} page_name="About Company" />
        
        <div className="about_us_banner_section">
            <div className="about_us_banner_inner_wrapper">
                <img src={bg_img_4} alt="" />
                
            </div>
            <div className="readings_section">
                <div className="readings_section_inner_wrapper">
                    <div className="column_1">
                        <p><span className="big_text">20 ýyldan</span> gowrak</p>
                        <p>tejribe</p>
                    </div>
                    <div className="column_2">
                        <p><span className="big_text">150-den</span> gowrak</p>
                        <p>hoşal galan müşderiler</p>
                    </div>
                    <div className="column_3">
                        <p><span className="big_text">200-den</span> gowrak</p>
                        <p>amala aşyrylan taslamalar</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="floating_section">
            <div className="about_us_section">
                <div className="inner_wrapper">
                    <img src={ygtyyarnama_img} className="margin_right" alt="" />
                    <div className="section_2_text_wrapper" style={{justifyContent: 'center'}}>
                        <p>
                            <b>“Sagdyn ülke” HK</b> - kärhana 2020-nji ýylda senagat ekologiýasy boýunça resminamalary işläp düzmek bilen meşgullanýan kärhana hökmünde esaslandyryldy. Biziň hünärmenlerimiz 20 ýyldan gowrak wagtyň dowamynda <b>ekologiýa degişli resminamalaryň</b> taslamalaryny düzmek boýunça tejribe toplady.
                        </p>
                        <p><b>“Sagdyn ülke” HK</b> sarp edijilere we kärhanalara biziň planetamyzy <b>geljekki nesiller</b> üçin goraýan jogapkär çözgütleri kabul etmäge mümkinçilik döredýär.</p>
                        <p>
                            Türkmenistanyň Prezidenti Gurbanguly Berdimuhamedowyň Permanyna laýyklykda, <b>“Tebigaty goramak hakyndaky”</b> kanun (Türkmenistanyň Mejlisiniň wedomostlary, 2014 ý., № 1, sah. 40), biziň testirlemek we sertifikasiýa boýunça amallara esaslanýan standartlarymyz sarp edijileriň ýokary howpsuzlygyny kepillendirýär.
                        </p>
                    </div>
                </div>
            </div>
            
           <OurPartnersSection />

           <ThanksLettersSection />

           <FeedbackSection />


        </div>
        
    </main>
    
  )
}

export default AboutCompanyPage